(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9372],{

/***/ 39372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Blog_NextArticle; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Blog/NextArticle/NextArticle.module.scss
var NextArticle_module = __webpack_require__(59761);
var NextArticle_module_default = /*#__PURE__*/__webpack_require__.n(NextArticle_module);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Icon/icons/right-arrow.inline.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgRightArrowinline = function SvgRightArrowinline(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.0039 3.414L2.39691 12.021L0.98291 10.607L9.58891 2H2.00391V0H13.0039V11H11.0039V3.414Z",
    fill: "#111315"
  })));
};

/* harmony default export */ var right_arrow_inline = (SvgRightArrowinline);
// EXTERNAL MODULE: ./src/components/Img/index.jsx
var Img = __webpack_require__(17876);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(86677);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./src/components/Blog/NextArticle/index.jsx







var NextArticle = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var data = param.data;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: (NextArticle_module_default()).card,
        onClick: function() {
            return router_default().push((data === null || data === void 0 ? void 0 : data.to) || "/blog");
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NextArticle_module_default()).header,
                children: [
                    "Read next",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(right_arrow_inline, {})
                ]
            }),
            (data === null || data === void 0 ? void 0 : data.featuredImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: data.featuredImage,
                className: (NextArticle_module_default()).featuredImage,
                width: 75,
                height: 75
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (NextArticle_module_default()).title,
                children: (data === null || data === void 0 ? void 0 : data.title) || "Untitled"
            }),
            (data === null || data === void 0 ? void 0 : data.tag) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NextArticle_module_default()).tag,
                children: data.tag
            })
        ]
    });
});
NextArticle.propTypes = {
    data: prop_types_default().shape({
        featuredImage: (prop_types_default()).string,
        title: (prop_types_default()).string,
        tag: (prop_types_default()).string,
        to: (prop_types_default()).string
    })
};
/* harmony default export */ var Blog_NextArticle = (NextArticle);


/***/ }),

/***/ 59761:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"NextArticle_card__9BSta","header":"NextArticle_header__nwzg9","title":"NextArticle_title__eswm0","tag":"NextArticle_tag__r6yHM","featuredImage":"NextArticle_featuredImage__gP_4V"};

/***/ })

}]);